import { TenantViewModel } from '@ail/customers-api'
import { TenantFuelCardSetViewModel } from '@ail/orders-api'
import { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect, ConnectedProps } from 'react-redux'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { wrapQuery } from '../../../redux/api/apiQuery'
import { customersApi } from '../../../redux/api/customerApi'
import { ordersApi } from '../../../redux/api/ordersApi'
import './GroupFuelCardSets.scss'
import { Loader } from '../../common/Loader/Loader'

type IGroupFuelCardSetsProps = ConnectedProps<typeof connector> & WithTranslation & RouteComponentProps<{ id?: string }>

interface IGroupFuelCardSetsState {
  tenantFuelCardSets: TenantFuelCardSetViewModel[]
  tenants: TenantViewModel[]
  loading: boolean
}

class GroupFuelCardSets extends Component<IGroupFuelCardSetsProps, IGroupFuelCardSetsState> {
  constructor(props: IGroupFuelCardSetsProps) {
    super(props)

    this.state = {
      tenantFuelCardSets: [],
      tenants: [],
      loading: false,
    }
  }

  public componentDidMount(): void {
    this.reload()
  }

  public render() {
    const { tenantFuelCardSets, tenants } = this.state
    const { loading } = this.state

    return (
      <Loader blocking={loading} style={{ overflow: 'hidden' }}>
        <div className="tfcsManArea">
          <div className="contractFilters reqFilters">
            <div className="leftContainer">
              <div className="reqTitle">
                <i className="icon-fuelcard" /> <span>Fuel card set List</span>
              </div>
            </div>
            <div className="rightFilters">
              <NavLink className="perPage" to="/RequestsManagement/GroupFuelCardSets/new">
                New Group Fuel Card Set
              </NavLink>
              <NavLink className="perPage" to="/RequestsManagement/FuelCards">
                Fuel Card List
              </NavLink>
              <NavLink className="perPage" to="/RequestsManagement">
                Forms List
              </NavLink>
              <NavLink to="/RequestsManagement/Workflows" className="perPage">
                Workflows List
              </NavLink>
            </div>
          </div>
          <div className="grid-wrap flat-no-paging">
            <ul className="reqHeader">
              <li>
                <div className="id">ID</div>
                <div className="owner">Owner</div>
                <div className="amount">Max Fuel Cards</div>
                <div className="amount">Amount of fuel cards</div>
                <div className="actions">Actions</div>
              </li>
            </ul>
            <ul className="reqList">
              {tenantFuelCardSets?.map((el) => (
                <li>
                  <div className="id">
                    <div>{el.id}</div>
                  </div>
                  <div className="owner">
                    <div>{tenants?.find((t) => t.id === el.tenantId)?.name || 'unknown'}</div>
                  </div>
                  <div className="amount">
                    <div>{el.maxFuelCards > 0 ? el.maxFuelCards : 'All'}</div>
                  </div>
                  <div className="amount">
                    <div>{el.fuelCards?.length || 0}</div>
                  </div>
                  <div className="actions">
                    <a>
                      <i
                        className="icon-clear"
                        onClick={() => {
                          this.delete(el.id)
                        }}
                      />
                    </a>
                    <NavLink to={`/RequestsManagement/GroupFuelCardSets/${el.id}`}>
                      <i className="icon-edit" />
                    </NavLink>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Loader>
    )
  }

  private reload() {
    this.setState({
      loading: true,
    })
    Promise.all([this.props.loadTenants(), this.props.getTenantFuelCardSets()])
      .then(([tenants, tenantFuelCardSets]) => {
        this.setState({ loading: false, tenants, tenantFuelCardSets })
      })
      .finally(() => this.setState({ loading: false }))
  }

  private delete(id: string) {
    const agree = window.confirm('Are you sure to delete this item?')
    if (agree) {
      this.setState({
        loading: true,
      })
      this.props.deleteTenantFuelCardSet(id).then(
        () => {
          this.reload()
        },
        () => {
          alert('Group fuel card set delete failed!')
          this.setState({
            loading: false,
          })
        }
      )
    }
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps() {
  return {}
}

/**
 * What action should be passed to component
 */
const mapDispatchToProps = {
  deleteTenantFuelCardSet: wrapQuery((id: string) => ordersApi.endpoints.deleteTenantFuelCardSet.initiate(id)),
  getTenantFuelCardSets: wrapQuery(() => ordersApi.endpoints.getTenantFuelCardSets.initiate()),
  loadTenants: wrapQuery(() => customersApi.endpoints.getTenants.initiate()),
}

const connector = connect(mapStateToProps, mapDispatchToProps)
// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(GroupFuelCardSets))
